import React from 'react';
import { SubSection, Rows, hasRows, money, yesno } from '../StatRows';
import SplitBar from '../charts/SplitBar';
import CostLadder from '../charts/CostLadder';

/* "Finance" accordion: athletics money (aid + recruiting) and then what a year
   actually costs a family.
   Mirrors `aidMoney` + `cost` in MatchDetailSheet.swift.

   "Avg grant aid" has no iOS/Android equivalent — web has always shown it and
   the payload carries it, so it stays. */

function build(detail) {
  const aid = detail.aid || {};
  const cost = detail.cost || {};
  return {
    aid,
    aidRows: [
      { label: 'Athletic aid / athlete', value: money(aid.athletic_aid_per_athlete) },
      { label: 'Total athletic aid', value: money(aid.athletic_aid_total) },
      { label: 'Recruiting budget', value: money(aid.recruiting_total) },
      { label: 'Division awards athletic $', value: yesno(aid.division_allows_athletic_aid) },
      { label: 'Avg net price (after aid)', value: money(aid.avg_net_price) },
      { label: 'Avg grant aid', value: money(aid.avg_grant_aid) },
    ],
    hasAidSplit: aid.athletic_aid_men != null || aid.athletic_aid_women != null,
    costBars: [
      { label: 'Out-of-state price', value: cost.out_of_state, highlighted: false },
      { label: 'In-state price', value: cost.in_state, highlighted: false },
      { label: 'Tuition & fees', value: cost.tuition_fees, highlighted: false },
      { label: 'Avg net price — what families pay', value: cost.net_price, highlighted: true },
    ],
  };
}

export function hasContent(detail) {
  const b = build(detail);
  return hasRows(b.aidRows) || b.hasAidSplit || b.costBars.some((x) => x.value != null);
}

export default function FinanceSection({ detail }) {
  const { aid, aidRows, hasAidSplit, costBars } = build(detail);

  return (
    <>
      <SubSection title="Athletics — Aid & Money" hasContent={hasRows(aidRows) || hasAidSplit}>
        <Rows rows={aidRows} />
        <SplitBar
          caption="Athletic aid — men / women"
          leftLabel="Men" rightLabel="Women"
          left={aid.athletic_aid_men} right={aid.athletic_aid_women}
          leftTone="blue" rightTone="gold"
        />
      </SubSection>

      <SubSection
        title="Cost — What a Year Costs"
        hasContent={costBars.some((b) => b.value != null)}
      >
        <CostLadder bars={costBars} />
      </SubSection>
    </>
  );
}
